/* istanbul ignore file */
import { array as codecArray } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { AssignmentSectionTimeframe } from './AssignmentSectionTimeframe';
import { TimeframeLike } from './TimeframeLike';
const AssignmentTimeframesParser = 
/* #__PURE__ */ parsers.object([
    ['general', TimeframeLike],
    ['sections', /* #__PURE__ */ codecArray(AssignmentSectionTimeframe)],
]);
export class AssignmentTimeframes extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AssignmentTimeframesParser.decode(input).map(res => new AssignmentTimeframes(res));
    }
    static unsafeDecode(input) {
        return AssignmentTimeframes.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AssignmentTimeframesParser.encode(data);
    }
    static schema() {
        return AssignmentTimeframesParser.schema();
    }
}
